import { useEffect, useState } from 'react';
import qs from 'query-string';
import { API_URL } from 'config/config';
import { getAllBanner } from 'service/base';
import { CONST_SITE } from 'utils/common/const';

function toAbsoluteUrl(src) {
  if (!src) return '';
  if (/^https?:\/\//i.test(src)) return src;
  const base = API_URL || '';
  const path = src.startsWith('/') ? src : `/${src}`;
  return `${base.replace(/\/$/, '')}${path}`;
}

/**
 * Banner bên phải — gọi API danh sách banner (getAllBanner), UI giống fe_client_ddts_f8bet RightGif.
 */
const RightGif = () => {
  const [banners, setBanners] = useState([]);
  const [error, setError] = useState(null);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await getAllBanner(qs.stringify({ site: CONST_SITE.OPEN88 }));
        const list = Array.isArray(response?.data)
          ? response.data
          : Array.isArray(response)
            ? response
            : [];
        if (list.length > 0) {
          const withImage = list.filter((b) => b?.image);
          setBanners(withImage);
          if (withImage.length === 0) {
            setError('No banner data found');
          }
        } else {
          console.warn('No banner data found in response');
          setError('No banner data found');
        }
      } catch (err) {
        console.error('Error fetching banners:', err);
        setError(err.message);
      }
    };

    fetchBanners();
  }, []);

  const handleClose = (e) => {
    e.stopPropagation();
    setIsVisible(false);
  };

  if (error || banners.length === 0) {
    return null;
  }

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed right-2 top-1/2 z-50 -translate-y-1/2 cursor-pointer lg:right-10">
      <button
        type="button"
        onClick={handleClose}
        className="absolute -right-2 -top-2 z-10 flex h-7 w-7 items-center justify-center rounded-full border-2 border-white bg-[#31a749] text-sm font-bold text-white"
      >
        ×
      </button>
      {banners.map((banner, index) => (
        <div className="flex" key={banner.id || banner._id || banner.image || index}>
          <a
            className="flex max-w-20 lg:max-w-[140px]"
            href={banner?.link ?? '#'}
            title={banner?.title}
          >
            <img
              src={toAbsoluteUrl(banner.image)}
              alt={banner?.title ?? `Banner ${index + 1}`}
              className="mb-2 h-auto w-full cursor-pointer"
            />
          </a>
        </div>
      ))}
    </div>
  );
};

export default RightGif;
